import { KeyValue } from "@/main/models/common";
import { AxiosResponse } from "axios";
import { PaginationResponse } from "../models/common/paginationResponse";
import { Result } from "../models/common/resultResponse";
import {
	AvailableUsersForHierarchyRequest,
	DeleteUserHierarchyRequest,
	SaveUserHierarchyRequest,
	UpdateUserHierarchyRequest,
	UserHierarchyFilterRequest,
} from "../models/request/userHierarchyRequest";
import { AvailableUsersHierarchyResponse, UserHierarchyTreeResponse } from "../models/response/userHierarchyResponse";
import { api } from "./base/api";
import { IUserHierarchyApi } from "./base/userHierarchyApi";

const baseRoute: string = "UserHierarchy";

export class UserHierarchyApi extends IUserHierarchyApi {
	getHierarchyTree(filter: UserHierarchyFilterRequest): Promise<AxiosResponse<Result<UserHierarchyTreeResponse[]>>> {
		return api.get(`${baseRoute}/tree`, { params: filter });
	}

	saveHierarchyTree(request: SaveUserHierarchyRequest): Promise<AxiosResponse<Result<any>>> {
		return api.post(`${baseRoute}/tree`, request);
	}

	getAvailableUsersForHierarchy(
		request: AvailableUsersForHierarchyRequest,
	): Promise<AxiosResponse<PaginationResponse<AvailableUsersHierarchyResponse[]>>> {
		return api.get(`${baseRoute}/available-users`, { params: request });
	}

	deleteHierarchyTree(request: DeleteUserHierarchyRequest): Promise<AxiosResponse<Result<any>>> {
		return api.delete(`${baseRoute}/tree`, { data: request });
	}

	putHierarchyTree(request: UpdateUserHierarchyRequest): Promise<AxiosResponse<Result<any>>> {
		return api.put(`${baseRoute}/tree/user`, request);
	}

	getLevelHierarchy(guidInsurer: string, idSystemApplication: number): Promise<AxiosResponse<KeyValue>> {
		return api.get(`${baseRoute}/GetLevelHierarchyByInsurer`, {
			params: { guidInsurer, idSystemApplication },
		});
	}
}
